// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.3816 6.19928L11.998 0.811035L3.61776 6.19957L4.69946 7.88181L4.99973 7.68873V11.1057L1.625 13.168L2.6679 14.8746L2.99973 14.6718V21.9998H11V16H13V21.9998H20.9997V14.6718L21.3316 14.8746L22.3745 13.168L18.9997 11.1057V7.68857L19.3003 7.88175L20.3816 6.19928ZM6.99973 9.88345V6.40272L11.9982 3.18865L16.9997 6.40316V9.88345L11.9997 6.8279L6.99973 9.88345Z"}}]};

const Building5FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'building-5-filled',
    ref,
    icon: element,
  },
));

Building5FilledIcon.displayName = 'Building5FilledIcon';

export default Building5FilledIcon;
